export default __webpack_public_path__ + "8c3bfef9364897e39448daa37486f98b.png";